"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "parseDuration", {
  enumerable: true,
  get: function () {
    return _tinyduration.parse;
  }
});
var _tinyduration = require("tinyduration");